// Serializes event/image saves so backend synchronization always sees the uploaded original.
// A failed image upload still saves the other fields and retains the previous poster selection.
export async function saveEventWithPoster({ data, previous, image, create, update, upload }) {
    const editableData = { ...data };
    // The public gallery switch has its own endpoint (PUT /event/{id}/public-gallery); the
    // event save never carries it, so a stale form cannot flip it.
    delete editableData.publicGalleryActive;
    let saved;
    let imageWarning = false;
    if (!previous?.id) {
        saved = await create({ ...editableData, hasCustomPosterImage: false, posterImageName: undefined });
        if (!image) return { event: saved, imageWarning };
    }
    const id = previous?.id || saved.id;
    let poster = { hasCustomPosterImage: data.hasCustomPosterImage, posterImageName: previous?.posterImageName };
    if (image) {
        // Unique original names prevent an overlapping save from changing another save's source.
        const extension = image.name.split('.').pop().toLowerCase();
        const name = `EventPoster-${crypto.randomUUID()}.${extension}`;
        try {
            await upload(id, name, image);
            poster = { hasCustomPosterImage: true, posterImageName: name };
        } catch {
            imageWarning = true;
            poster = { hasCustomPosterImage: previous?.hasCustomPosterImage ?? false, posterImageName: previous?.posterImageName };
        }
    }
    const payload = { ...previous, ...saved, ...editableData, ...poster, id, code: saved?.code || data.code };
    delete payload.publicGalleryActive;
    saved = await update(payload);
    return { event: saved, imageWarning };
}
